export default function navMenu() {
    const elNavIcon = document.querySelector('.js-nav-btn'),
        elMainNav = document.querySelector('.main-nav'),
        screenTablet = 1024;

    if(window.innerWidth < screenTablet) {
        elMainNav.style.display = 'flex';
    }

    elNavIcon.addEventListener('click', function H() {
        this.children[0].classList.toggle('page-header__nav-icon--active');
        elMainNav.classList.toggle('main-nav--active');
    }, true);

    window.addEventListener('resize', () => {
        if(window.innerWidth < screenTablet) {
            elMainNav.style.display = 'flex';
        } else {
            elMainNav.style.removeProperty('display');
        }
    });
}
